import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { isCoreInitializingSelector, itemsSelector } from '../selectors';
import { fetchDailyReports, fetchMonthlyReports, fetchYearlyReports } from '../actions/entry';
import ChartCompare from '../components/Report/ChartCompare';

const mapStateToProps = (state) => {
  const isCoreInitializing = isCoreInitializingSelector(state);
  const items = itemsSelector(state);
  const { dailyReport, monthlyReport, yearlyReport } = state.reports;
  return {
    items,
    dailyReport,
    monthlyReport,
    yearlyReport,
    isInitializing: isCoreInitializing,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onChangeDaily: fetchDailyReports,
      onChangeMonthly: fetchMonthlyReports,
      onChangeYearly: fetchYearlyReports,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ChartCompare);
